var XPortal = XPortal || {};
XPortal.Utils = (function () {
    var utils = {};

    String.prototype.rtrim = function (s) {
        if (s == undefined)
            s = '\\s';
        return this.replace(new RegExp("[" + s + "]*$"), '');
    };
    String.prototype.ltrim = function (s) {
        if (s == undefined)
            s = '\\s';
        return this.replace(new RegExp("^[" + s + "]*"), '');
    };
    utils.EnsureCollectionDefer = function (eventname, adjustEvent, elementsToProcess) {
        var deferred = $.Deferred();
        utils.EnsureCollectionEvent(eventname, adjustEvent, elementsToProcess, function () { deferred.resolve(); });
        return deferred.promise();
    };
    utils.EnsureCollectionEvent = function (eventname, adjustEvent, elementsToProcess, callBack) {
        var itemsToProcess = elementsToProcess.length;
        if (itemsToProcess < 1) return callBack();


        var procesed = $.map(elementsToProcess, function (xel) {
            var e = jQuery.Event(eventname);
            e = adjustEvent ? adjustEvent(e) : e;
            e.ondone = function (d) {
                itemsToProcess--;
                if (itemsToProcess < 1) callBack();
            };
            $(xel).trigger(e);
            if (!e.isDefaultPrevented()) e.ondone(e);
        });
    };
    utils.readJsonStr = function (str, defObj) {
        if (!str || str.length === 0) return defObj;
        try {
            return JSON.parse(str);
        } catch (e1) {
            try {
                var f = new Function('const a=' + str + ';return a;');
                var rx = f();
                return rx;
            } catch (e2) {
                if (console && console.log) console.log("can't read json. error", { e2, e1, str });
            }
        }
        return defObj;
    }
    utils.ValidateForm = function (fields, xfrm, options, skippSelector) {
        var deferred = $.Deferred();
        var toCheck = $(fields);
        setTimeout(function () {
            var r = true; //looks like r is a result of whole validation process don't call variables like 'r'
            var focused = false; //focused looks more clear
            xfrm.validate();
            toCheck.each(function () {
                var $this = $(this);
                if ($this.attr("data-val") == "true") {
                    const dmfname = $this.attr("data-metadata-fieldname");
                    if ($this.is(".xpand-dropdown") && !dmfname) {
                        r = r;
                    }
                    else {
                        if (skippSelector && $this.is(skippSelector)) r = r;
                        else {
                            var ri = XPortal.Validation.ValidateElement($this, xfrm, options.doNotDisplayErrors, options.IsCreating);
                            r = r && ri;
                            if (!focused && !r && !options.doNotDisplayErrors) {
                                focused = true;
                                var tabPanel = $(this).closest("div.xportal-tab-panel");
                                if (tabPanel.length > 0 && !tabPanel.hasClass("active")) {
                                    let currentActiveTab = tabPanel.closest("div.tab-content").find("div.xportal-tab-panel.active.show");
                                    currentActiveTab.removeClass("active show");
                                    $("li.nav-item>.active.show").removeClass("active show");
                                    $("#" + tabPanel.attr("aria-labelledby")).addClass("active show");
                                    tabPanel.addClass("active show");
                                }
                                if ($this.add($this.closest(".k-widget")).is(":visible")) $this.focus();
                            }
                        }
                    }
                }
            });
            //send validation result to store
            var detailElement = xfrm.closest("[id^=detail-page-]");
            if (detailElement.length > 0) {
                var modelName = XPortal.Store.getModelName(detailElement);
                var state = XPortal.Store.GetState();
                if (!state.pageModels[modelName].WasValidated) XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.VALIDATION_RESULT, modelName, valid: r });
            }
            if (r) deferred.resolve(); else deferred.reject();
        }, 1);
        return deferred.promise();
    };

    utils.empty = function (el) {
        if (!el) return;

        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }
    };
    utils.htmlIsEmpty = function (str) {
        const el = $("<div></div>");
        el.html(str);
        const txt = (el.text() || "").trim();
        return !txt.length;
    };

    utils.guid = function () {
        var _4 = function () { return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1); };
        return _4() + _4() + '-' + _4() + '-' + _4() + '-' + _4() + '-' + _4() + _4() + _4();
    };
    utils.makeRandomString = function (length) {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    };

    utils.getViewportWidth = function () {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    };

    utils.getViewportName = function () {
        var viewportWidth = utils.getViewportWidth();

        if (viewportWidth < 576) {
            return 'xs';
        } else if (viewportWidth >= 576 && viewportWidth < 768) {
            return 'sm';
        } else if (viewportWidth >= 768 && viewportWidth < 992) {
            return 'md';
        } else if (viewportWidth >= 992 && viewportWidth < 1200) {
            return 'lg';
        } else {
            return 'xl';
        }
    };

    utils.getViewportState = function ($obj) {
        $obj = $($obj);
        if ($obj.length < 1) return {};
        var xresult = utils.getViewportStateByClasses($obj.attr('class'));
        return xresult;
    };
    const spVportRx = /^col\-(\d{1,2})$/;
    const spVportSt = ["xl", "lg", "md", "sm", ""];
    utils.getViewportStateByClasses = function (classes) {
        const szClasses = $.grep(classes.split(' '), function (v, i) { return v.indexOf('col-') === 0; });
        const res = _.map(spVportSt, ix => {
            if (ix) {
                const szi = _.find(szClasses, function (clx) {
                    return clx.indexOf("col-" + ix) == 0;
                });
                if (!szi) return 12;
                return parseInt(szi.substring(7));
            } else {
                const szi = _.find(szClasses, clx => spVportRx.test(clx));
                return szi ? parseInt(szi.substring(4)) : 12;
            }
        });
        return res;
    };

    utils.createViewportCssClasses = function (classes) {
        if (!classes || classes.length != 5) return;
        const res = _.map(spVportSt, (ix, ii) => {
            return utils.createViewportCssClass(ix, classes[ii]);
        });
        return res.join(' ');
    };

    utils.getViewportStateForCurrentResolution = function (cssClass, prefix) {
        var matrix = utils.getViewportStateByClasses(cssClass);
        var result;

        switch (prefix) {
            case 'xl':
                result = matrix[0];
                break;
            case 'lg':
                result = matrix[1];
                break;
            case 'md':
                result = matrix[2];
                break;
            case 'sm':
                result = matrix[3];
                break;
            case 'xs':
                result = matrix[4];
                break;
            default:
                result = 12;
        }

        return result;
    };

    utils.createViewportCssClass = function (prefix, num) {
        return `col-${prefix}-${num}`.replace('--', '');
    };

    utils.gridSystem = [
        { grid: 8.33333333, col: 1 },
        { grid: 16.66666667, col: 2 },
        { grid: 25, col: 3 },
        { grid: 33.33333333, col: 4 },
        { grid: 41.66666667, col: 5 },
        { grid: 50, col: 6 },
        { grid: 58.33333333, col: 7 },
        { grid: 66.66666667, col: 8 },
        { grid: 75, col: 9 },
        { grid: 83.33333333, col: 10 },
        { grid: 91.66666667, col: 11 },
        { grid: 100, col: 12 },
        { grid: 10000, col: 10000 }
    ];

    utils.unzipToJson = function (urlString, fileName) {
        try {
            var zip2 = new JSZip(urlString, { "base64": true });
            var r = null;
            if (fileName && fileName.length > 0) r = zip2.file(fileName).asText();
            else {
                for (var i in zip2.files)
                    r = r && r.length > 0 ? r : zip2.files[i].asText();
            }
        } catch (e) {
            r = urlString;
        }
        return r;
    };

    utils.formatString = function () {
        var stringTempl = arguments[0];
        if (!stringTempl) return;

        if (arguments.length == 1) return stringTempl;
        for (i = 1; i < arguments.length; i++) {
            var regObj = arguments[i].regex ? arguments[i].regex : new RegExp("\\{" + (i - 1) + "\\}");
            var rText = (typeof arguments[i].text !== typeof undefined) ? arguments[i].text : arguments[i];
            stringTempl = stringTempl.replace(regObj, rText);
        }
        return stringTempl;
    };

    utils.decodeTemplate = function (value) {
        return $('<textarea />').html(value || "").text();
    };

    utils.customISOstring = function (date, offset) {
        var newDate = new Date(date), // copy instance
            h = Math.floor(Math.abs(offset) / 60),
            m = Math.abs(offset) % 60;
        newDate.setMinutes(date.getMinutes() - offset); // apply custom timezone
        function pad(n) { return n < 10 ? '0' + n : n }
        return newDate.getUTCFullYear() + '-' // return custom format
            + pad(newDate.getUTCMonth() + 1) + '-'
            + pad(newDate.getUTCDate()) + 'T'
            + pad(newDate.getUTCHours()) + ':'
            + pad(newDate.getUTCMinutes()) + ':'
            + pad(newDate.getUTCSeconds())
    };

    utils.textToJson = function (str) {//todo - reuse:utils.readJsonStr
        rdata = !!!str ? str.trim() : str;
        try {
            rdata = JSON.parse(rdata);
        } catch (e) {
            rdata = rdata.split("\n").slice(1).join("\n");
            rdata = !!!rdata ? rdata.trim() : rdata;
            rdata = JSON.parse(rdata);
        };
        return rdata;
    };
    utils.CompareUrlPaths = function (strA, strB, o) {
        strA = strA || "";
        strB = strB || "";
        if (strA.length == 0 && strB.length == 0) return true;
        try {
            const urlA = new URL(strA, window.location.href);
            const urlB = new URL(strB, window.location.href);
            if (urlA.pathname == urlB.pathname) return true;
            return false;
        } catch (e) {
            return false;
        }
    };
    utils.GetPathFromUrl = function getPathFromUrl(url_string) {
        try {
            const url = new URL(url_string, window.location.href);
            // Combine the path, query parameters, and anchor hash
            const path = url.pathname + url.search + url.hash;
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return url_string;
        }
    };
    utils.hrefQuery = function (href, query, takeLeftPart, takeAllSubstring) {

        if (takeLeftPart) {
            if (href.indexOf(query) < 0) return false;
            var result = href.slice(href.indexOf(query) + query.length + 1)
        } else {
            resultId = takeAllSubstring ? 0 : 1;
            query = query.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            let expr = "[\\?&]" + query + "=([^&#]*)";
            let regex = new RegExp(expr);
            let results = regex.exec(href);
            result = results && results.length > 1 ? results[resultId] : null;
        }
        if (result !== null) {
            return decodeURIComponent(result);
        } else {
            return false;
        }
    };
    utils.updateQueryStringParameter = function (uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            return uri + separator + key + "=" + value;
        }
    };
    utils.EnsureInProfile = function (surl) {
        if (!surl || surl.length < 1) return surl;
        const curl = new URL(window.location.href);
        const ikey = curl.searchParams.keys().find(x => x.toLowerCase() == "umbdebug");
        if (!ikey) return surl;
        if ((curl.searchParams.get(ikey) || "").toLowerCase() != "true") return surl;

        const ourl = new URL(surl, curl.origin);
        ourl.searchParams.set("umbDebug", "true");
        surl = ourl.toString();
        return surl;
    };
    utils.EnsureActionInProfile = function ($items) {
        if (!$items || !$items.length) return $items;
        $items.each(function () {
            const $item = $(this);
            const iurl = $item.attr("action");
            const url = XPortal.Utils.EnsureInProfile(iurl);
            if (iurl != url) {
                $item.attr("action", url);
            }
        });
        return $items;
    };
    utils.AddProfileLink = function () {
        XPortal.Utils.waitFor(function () {
            const el = $(".mp-popup .mp-links");
            if (el.length < 1) return false;
            const path = "/mini-profiler-resources/";
            const ai = $("<a href=\"#\" class=\"mp-all-results-refresh\" >refresh all</a>");
            el.append(ai);
            const refreshListOfProfilers = function () {
                el.closest(".mp-output").find(".all-profiles-list").remove();
                fetch(path + "results-list?last-id=" + utils.guid(), { method: "GET", headers: { Accept: "application/json", "Content-Type": "application/json" } }).then(function (n) { return n.json() }).then(r => {
                    let o = "";
                    const f = function (n, t) {
                        return n.ClientTimings.Timings.filter(n => n.Name === t)[0] || {
                            Name: t,
                            Duration: "",
                            Start: ""
                        };
                    };
                    const pnf = function (v, suff) {
                        const n = Number(v);
                        return isNaN(n) ? "-" + suff : n.toLocaleString(undefined, { minimumFractionDigits: 2 }) + suff;
                    };
                    const sf = function (n) {
                        const esc = htmlEscape(n);
                        try {
                            if (!esc || !esc.trim()) return [esc];
                            const u = new URL(esc);
                            const stitle = (u.searchParams.get("pfs") || "");
                            if (u.pathname.toLowerCase().indexOf("umbraco") < 0) return [u.pathname, stitle];
                            const parts = u.pathname.split('/');
                            if (parts.length > 1) return [parts[parts.length - 2] + "/" + parts[parts.length - 1], stitle];

                            return [parts[parts.length - 1], stitle];
                        } catch (e) {
                            if (console) console.log("profile issue-", e);
                        }
                        return [esc];
                    };
                    const af = function (n, t, tt) {
                        return '<a href="' + path + "results?id=" + n.Id + '" title="' + (htmlEscape(tt ? tt : t)) + '" target="_blank">' + t + "<\/a>";
                    };
                    r = _.sortBy(r, x => { x.srtid = moment(x.Started).format('YYYY_MM_DD_HH_mm_ss_SSS'); return x.srtid; }).reverse();
                    r.forEach(function (n) {
                        const nnames = sf(n.Name).join("/");
                        o += '\n<tr title="' + htmlEscape(n.Name) + '"><td class="mp-results-index-date" >' + af(n, moment(n.Started).format("HH:mm:ss"), moment(n.Started).format("YYYY.MM.DD HH:mm:ss")) + '<\/td><td>' + nnames + "<\/td><td style='text-align:right;'>" + af(n, pnf(n.DurationMilliseconds, "ms")) + "<\/td><\/tr>"
                    });


                    const tbl = $("<table style='padding:20px;0px;0px;0px;' class='all-profiles-list'><thead><tr><th colspan='3' style='border-bottom:inset 2px;'>&nbsp;</th></tr></thead></table>");
                    tbl.append($(o));

                    el.closest(".mp-output").append(tbl);
                });
            };
            $(document).on("click", ".mp-output .mp-all-results-refresh", function (e) {
                e.preventDefault();
                refreshListOfProfilers();
            });

            refreshListOfProfilers();
            return true;
        }, XPortal.Utils.waitFor, 500, 5);
    };

    htmlEscape = function (n) {
        return (n || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;")
    };
    utils.MarkVisited = function (logOptions) {

        var logUrl = logOptions.Element.attr("data-log-url") ? logOptions.Element.attr("data-log-url") : logOptions.Element.find("[data-log-url]").attr("data-log-url");
        if (!logUrl) { return; }
        if (!logOptions.Request) //if request is empty we get items from  logOptions.Element
        {
            const uid = XPortal.Utils.hrefQuery(logUrl, 'uid');
            logOptions.Request = {
                Items: uid ? [uid] : null,
                NodeId: XPortal.Utils.hrefQuery(logUrl, 'node') || 0
            };
            logOptions.MarkPattern = "li.k-file.k-file-success";
            $(logOptions.Element).find(".k-file-shortname").click(function () {
                $(this).addClass("xpand-visited");
            });
        }

        XPortal.Utils.APIPost(logUrl, logOptions.Request)
            .then(function (xdata) {
                if (xdata.Items && xdata.Items.length > 0) {
                    if (xdata.Items[0].ActionDetails) { //action details present
                        xdata.Items.map(i => { i.file = JSON.parse(i.ActionDetails).Value; return i; });
                    }
                    $(this.grid).find(this.pattern).each(function () {
                        if (this.href) { //grid cell
                            downloadId = XPortal.Utils.hrefQuery(this.href, 'id');
                            if (downloadId && xdata.Items.find(i => i == downloadId)) {
                                $(this).addClass("xpand-visited");
                            }
                        }
                        else {
                            var aHref = $(this).find("[filename]");
                            var file = $(this).find("[filename]").attr("filename");
                            if (file && xdata.Items.find(i => i.file == file)) {
                                aHref.addClass("xpand-visited");
                            }
                        }
                    });
                }
            })
            .fail(function (...args) {
                console.warn(args);
            });
    };

    utils.bodyScrollWidth = function () {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

        document.body.appendChild(outer);

        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";

        // add innerdiv
        var inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);

        var widthWithScroll = inner.offsetWidth;

        // remove divs
        outer.parentNode.removeChild(outer);

        return widthNoScroll - widthWithScroll;
    };

    utils.isElementInView = function ($element, $parent, fullyInView, div, div2) {
        var pageTop = $parent.scrollTop();
        var pageBottom = pageTop + $parent.height() - div2;
        var elementTop = pageTop + $element.offset().top - div;
        var elementBottom = elementTop + $element.height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    };

    utils.isElementVisible = function ($obj) {
        return utils.isElementInsideVisibleTabsOrDD($obj) && utils.isElementInView($obj, $('.content-wrapper'), false, 80, 0);
    };

    utils.isElementInsideVisibleTabsOrDD = function ($obj) {
        return (!$obj.closest('.xportal-dd-panel').length && !$obj.closest('.xportal-tab-panel').length)
            || $obj.closest('.xportal-dd-panel:not(.d-none)').length
            || $obj.closest('.xportal-tab-panel.active').length;
    };

    utils.isTouchDevice = function () {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        var mq = function (query) {
            return window.matchMedia(query).matches;
        }

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }

        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    };

    utils.getPosition = function (el) {
        var x = 0;
        var y = 0;
        while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
            x += el.offsetLeft - el.scrollLeft;
            y += el.offsetTop - el.scrollTop;
            el = el.offsetParent;
        }
        return { top: y, left: x };
    };

    utils.unique = function (array) {
        return $.grep(array, function (el, index) {
            return index == $.inArray(el, array);
        });
    };

    utils.getDataAttributes = function (target, ignoreAttributes, isArray, onlyValues) {
        var dataAttributes = isArray ? [] : {};
        if (!ignoreAttributes) {
            ignoreAttributes = [];
        }

        $.each(target.get(0).attributes, function (i, attr) {
            if (attr.name.indexOf('data-') === 0 && $.inArray(attr.name, ignoreAttributes) === -1) {
                if (isArray) {
                    dataAttributes.push(!onlyValues ? (attr.name + '="' + attr.value.toLowerCase() + '"') : attr.value.toLowerCase());
                } else {
                    dataAttributes[attr.name] = attr.value;
                }
            }
        });

        return dataAttributes;
    };

    utils.ScrollTo = function ($obj, $objToScroll) {
        var minRange = 500,
            maxRange = 1500;

        var bodyScrollTop = $obj.scrollTop();
        var scrollTop = $objToScroll.offset().top + bodyScrollTop - 60;
        var animationTime = Math.abs(bodyScrollTop - scrollTop) / 3;
        animationTime = animationTime < minRange ? minRange : (animationTime > maxRange ? maxRange : animationTime);

        $objToScroll.addClass('scrolling-to-obj');
        $obj.addClass('scrolling-wrapper');
        $obj.stop().animate(
            { scrollTop: scrollTop },
            animationTime,
            function () {
                $objToScroll.removeClass('scrolling-to-obj');
                $obj.removeClass('scrolling-wrapper');
            }
        );
    };

    utils.drowLine = function (x1, y1, x2, y2, $line) {
        var diffX = x1 - x2;
        var diffY = y1 - y2;
        var distance = Math.sqrt(diffX * diffX + diffY * diffY);
        var xMid = (x1 + x2) / 2;
        var yMid = (y1 + y2) / 2;

        var salopeInRadian = Math.atan2(diffY, diffX);
        var salopeInDegrees = salopeInRadian * 180 / Math.PI;

        $line.css({
            'width': distance,
            'top': yMid,
            'left': xMid - distance / 2,
            'transform': 'rotate(' + salopeInDegrees + 'deg)'
        });
    };

    utils.identifyKendoPopup = function (e) {
        setTimeout(function () {
            var $cnt = $(".k-list-container").closest(".k-animation-container");
            if (!$cnt.length)
                return;

            $cnt.addClass("xpand-dropdown-popup");
            e.sender.input && e.sender.input.closest('.k-grid').length && $cnt.addClass("in-k-grid");
        }, 0); //because we cannot get event kendo render poup html, we need to wait
    };

    utils.removeKendoPopupClass = function (e) {
        var $cnt = $(".k-list-container").closest(".k-animation-container");
        if (!$cnt.length)
            return;

        $cnt.removeClass("xpand-dropdown-popup");
    };

    utils.updateKendoObj = function (obj, mObj) {
        if (!mObj) return obj;
        const hasSetAct = obj["set"] ? true : false;
        for (var i in mObj) {
            if (hasSetAct) obj.set(i, mObj[i]);
            else obj[i] = mObj[i];
        }
        return obj;
    };
    utils.waitFor = function (onAction, onFalse, tinterval, trycount, onTimeout = null) {
        if (!isNaN(trycount) && trycount == 0) {
            if (onTimeout) onTimeout();
            return true;
        }
        tinterval = isNaN(tinterval) || tinterval < 1 ? 100 : tinterval;
        trycount = isNaN(trycount) || trycount < 1 ? 50 : trycount;
        if (!onAction()) {
            trycount--;
            setTimeout(function () {
                onFalse(onAction, onFalse, tinterval, trycount, onTimeout);
            }, tinterval);
        }
    };
    utils.waitAndExec = async function (one, other, tm) {
        tm = tm > 0 ? tm : 100;
        if (await one()) return;
        setTimeout(function () { other(one, other, tm); }, tm);
    };
    utils.getParentTabById = function (id) {
        return $(`#tabitm-content-${id}, .xportal-dd-panel.content-${id}`);
    };
    utils.GetPageTree = function (baseSelector) {
        var structPoints = [".xsection", ".xblock", ".xitem", ".toolbar", ".xbaction", ".snippet-item-cnt"];
        var srtructSel = structPoints.join(", ");
        var $b = baseSelector ? $(baseSelector) : $("body");
        var result = { p: $b, itms: [$b], c: [] };
        var c = [result];
        while (c && c.length > 0) {
            var lc = [];
            $.each(c, function () {//for each current level tree points
                var point = this;
                while (point.itms && point.itms.length > 0) {
                    var sitms = [];
                    $.each(point.itms, function () {
                        var $ci = $(this);
                        var $cip = $ci.children(srtructSel);
                        if ($cip.length > 0) {//sub item is found - add to point stop processing
                            $ci.children().each(function () {
                                if ($(this).is(srtructSel))
                                    point.c.push({ p: $(this), itms: [$(this)], c: [] });
                                else {
                                    var deepPoint = utils.GetPageTree($(this));
                                    $.each(deepPoint.c, function () { point.c.push(this); });
                                }
                            });
                        } else //process sublevels
                            $ci.children().each(function () { sitms.push($(this)); });
                    });
                    if (point.c.length > 0)
                        $.each(point.c, function () {
                            lc.push(this);//register to process next level
                        });
                    point.itms = sitms;
                };
                point.itms = [];
                delete point.itms;
            });
            c = lc;
        };

        utils.travelsTree = function (troot, onItem) {
            var c = [troot];
            while (c && c.length > 0) {
                var lc = [];
                $.each(c, function () {
                    var x = this;
                    var xthis = this;
                    if (x.tnPrnt) onItem(xthis = x.item, x.tnPrnt); else onItem(x);
                    $.each(xthis.c, function () {
                        lc.push({ tnPrnt: x, item: this });
                    });
                });
                c = lc;
            };
        };
        utils.GetNodeTreeParents = function (nPitem, rootId) {
            var r = [];
            while (nPitem) {
                if (nPitem.item) r.push(nPitem.item); else r.push(nPitem);
                if (nPitem.item) nPitem = nPitem.tnPrnt; else nPitem = null;
            }
            return r;
        };
        return result;
    };
    utils.TransformDateTime = function (data, frmt, skipFormat = false, returnNullIfError = false, returnMomentObject = false, simpleDataAsUtc = false, toUtc = false, adjustTZOffset = true) {

        if (!data || data.length == 0) {
            if (false && console) console.log("Data is not processed - data value is empty.");
            return returnNullIfError ? null : data;
        }
        var typeOfOperation = "UTC";
        var processingData = data instanceof Date ? data.toISOString() : moment.utc(data).toISOString() || "";
        var finalDateValue;
        var tzOffset = utils.getMemberTzOffset(XPortal.Account);
        var momentValidFormat = frmt ? XPortal.Template.formatDateToMomment(frmt) : processingData.indexOf("-") > -1 ? "YYYY-MM-DD h:mm:ss A" : "MM/DD/YYYY h:mm:ss A";
        var processingFormat = skipFormat ? "" : momentValidFormat.length > 0 ? momentValidFormat : processingData.indexOf("-") > -1 ? "YYYY-MM-DD h:mm:ss A" : "MM/DD/YYYY h:mm:ss A";
        if (data.processed)
            return returnMomentObject ? moment(data) : moment(data).format(momentValidFormat);

        if (processingData[processingData.length - 1] && processingData[processingData.length - 1].toLowerCase() == 'z') {
            finalDateValue = adjustTZOffset ? moment.utc(processingData).utcOffset(tzOffset) : moment.utc(processingData);
        } else {
            finalDateValue = simpleDataAsUtc ?
                (adjustTZOffset ? moment.utc(processingData, processingFormat).utcOffset(tzOffset) : moment.utc(processingData, processingFormat))
                : moment(processingData, processingFormat);

            typeOfOperation = "Simple";
        }

        if (!finalDateValue.isValid()) {
            if (false && console) console.log(processingData + " with format:" + frmt + " - final date object is not valid. Returned as is.");
            return returnNullIfError ? null : processingData;
        }

        if (false && console) console.log((toUtc ? "[local->UTC]" : "[UTC->local] ") + processingData + " | " + finalDateValue.format('YYYY-MM-DD HH:mm:ss') + " | " + typeOfOperation, { before: processingData, after: finalDateValue });
        return returnMomentObject ? finalDateValue : finalDateValue.format(momentValidFormat);
    };

    utils.AdjustDT = function (date, isUIMode = true) {
        if (!date || date.processed)
            return date;
        date = date instanceof Date ? date : moment.utc(date).toDate();
        var tShift = date.getUTCHours() +
            ((
                (XPortal.Utils.getMemberTzOffset(XPortal.Account) - (new Date().getTimezoneOffset() * -1)) *
                (isUIMode ? 1 : -1)
            ) / 60);
        date.setUTCHours(tShift);
        date.processed = true;
        return date;
    };

    // ISO date-time shape checks; date-only ("2026-06-23") values give false
    var dtCore = "\\d{4}-\\d{2}-\\d{2}[T ]\\d{2}:\\d{2}(?::\\d{2})?(?:\\.\\d+)?";
    var dtAnyRx = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/;
    var dtNaiveRx = new RegExp("^" + dtCore + "$");
    var dtUtcMarkedRx = new RegExp("^" + dtCore + "(?:Z|[+-]\\d{2}:?\\d{2})$");
    utils.IsDateTimeValue = function (v) { // any date-time shaped value, marker or not
        return typeof v === "string" && dtAnyRx.test(v);
    };
    utils.IsNaiveDateTimeValue = function (v) { // no Z/offset marker
        return typeof v === "string" && dtNaiveRx.test(v);
    };
    utils.IsUtcMarkedDateTimeValue = function (v) { // Z or +hh:mm marker required
        return typeof v === "string" && dtUtcMarkedRx.test(v);
    };
    utils.FormatDateTimeNaive = function (d) { // member-local "YYYY-MM-DDTHH:mm:ss", no marker
        return moment(d).format("YYYY-MM-DD[T]HH:mm:ss");
    };
    // Converts a tz-qualified system datetime (...Z or ...+-hh:mm) into the member-local naked-ISO frame the edit form uses.
    // Naked datetimes and non-datetime values are returned unchanged.
    utils.NormalizeSystemDateTime = function (data) {
        if (utils.IsUtcMarkedDateTimeValue(data)) {
            var d = utils.AdjustDT(data, true);
            if (d instanceof Date && !isNaN(d.getTime())) return utils.FormatDateTimeNaive(d);
        }
        return data;
    };

    utils.getMemberTzOffset = function (maccount) {
        maccount = maccount || XPortal.Account;
        var curDate = new Date();
        var isDstObserved = utils.isDstObserved(curDate);
        var usrTzOffset = isNaN(maccount.userTimeZoneOffset) ? -1 * curDate.getTimezoneOffset() : maccount.userTimeZoneOffset;
        usrTzOffset += maccount.userTimeZoneUseDST && isDstObserved ? 60 : 0;
        var usrTzOffsetSrv = 0;// isNaN(maccount.userTimeZoneOffsetSrv) ? 0 : maccount.userTimeZoneOffsetSrv;
        var resTzOffset = usrTzOffset - usrTzOffsetSrv;
        return resTzOffset;
    };
    utils.stdTimezoneOffset = function (curDate) {
        var jan = new Date(curDate.getFullYear(), 0, 1);
        var jul = new Date(curDate.getFullYear(), 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    };
    utils.isDstObserved = function (curDate) {
        if (!curDate)
            curDate = new Date();

        return curDate.getTimezoneOffset() < XPortal.Utils.stdTimezoneOffset(curDate);
    };
    utils.RenderHtmlPercentBar = function (barname, dataVal) {
        if (barname == '30%') {
            if (!dataVal || dataVal <= 0) return '';

            var color;
            if (dataVal >= 100) {
                color = 'MediumSeaGreen';
            } else if (dataVal >= 30) {
                color = 'Orange';
            } else {
                color = 'DodgerBlue';
            }

            return '<div class="progress-bar__wrapper">' +
                        '<div class="progress-bar__bg">' +
                            '<div class="dynamic-bar" style="width:calc(' + dataVal + '%); background-color:' + color + ';"></div>' +
                        '</div>' +
                        '<span class="progress-bar__text">' + dataVal + '%</span>' +
                    '</div>';
            }
            return dataVal;

    };
    utils.isObjEmpty = function (obj) {
        return Object.values(obj).length === 0 && obj.constructor === Object;
    };
    utils.parseNumber = function (value) {
        value = value.replace ? value.replace(',', ".") : value;
        return isNaN(Number(value)) ? null : Number(value);
    };
    utils.isPageScrolledToBottom = function () {
        var scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        var documentHeight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.clientHeight,
            document.documentElement.scrollHeight,
            document.documentElement.offsetHeight
        );
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var bottomPosition = documentHeight - viewportHeight;
        return (Math.ceil(scrollPosition) >= bottomPosition);
    };
    utils.checkIfColorCssInString = function (string) {
        const colorRegex = /color:\s*(rgb\(\d+,\s*\d+,\s*\d+\)|rgba\(\d+,\s*\d+,\s*\d+,\s*[\d.]+\)|#[0-9a-fA-F]{6}|#[0-9a-fA-F]{3})/;
        const match = string.match(colorRegex);
        if (match && match[0]) {
            const colorValue = match[0];
            return colorValue;
        } else {
            return false;
        }
    };

    utils.isElementInViewport = function (classNameSelector) {
        const element = document.querySelector(classNameSelector);
        const rect = element.getBoundingClientRect();

        return (

            Math.round(rect.top) >= 0 &&
            Math.round(rect.left) >= 0 &&
            Math.round(rect.bottom) <= (window.innerHeight || document.documentElement.clientHeight) &&
            Math.round(rect.right) <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    utils.APIPost = function (url, data, options) {
        options = options || {};
        var deferred = $.Deferred();
        $.ajax({
            url: utils.EnsureInProfile(url),
            type: 'POST',
            dataType: 'json',
            contentType: options.contentType || 'application/json; charset=utf-8',
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            data: options.raw ? data : kendo.stringify(data),
            cache: false,
            success: function (r) { deferred.resolve(r); },
            error: function (e) { deferred.reject(e); }
        });
        return deferred.promise();
    };

    return utils;
}());

(function () {
    var attachEvent = document.attachEvent;
    var isIE = navigator.userAgent.match(/Trident/);
    if (false && console) console.log(isIE);
    var requestFrame = (function () {
        var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
            function (fn) { return window.setTimeout(fn, 20); };
        return function (fn) { return raf(fn); };
    })();

    var cancelFrame = (function () {
        var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame ||
            window.clearTimeout;
        return function (id) { return cancel(id); };
    })();

    function resizeListener(e) {
        var win = e.target || e.srcElement;
        if (win.__resizeRAF__) cancelFrame(win.__resizeRAF__);
        win.__resizeRAF__ = requestFrame(function () {
            var trigger = win.__resizeTrigger__;
            trigger.__resizeListeners__.forEach(function (fn) {
                fn.call(trigger, e);
            });
        });
    }

    function objectLoad(e) {
        this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__;
        this.contentDocument.defaultView.addEventListener('resize', resizeListener);
    }

    window.addResizeListener = function (element, fn) {
        if (!element.__resizeListeners__) {
            element.__resizeListeners__ = [];
            if (attachEvent) {
                element.__resizeTrigger__ = element;
                element.attachEvent('onresize', resizeListener);
            }
            else {
                if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
                var obj = element.__resizeTrigger__ = document.createElement('object');
                obj.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;');
                obj.__resizeElement__ = element;
                obj.onload = objectLoad;
                obj.type = 'text/html';
                if (isIE) element.appendChild(obj);
                obj.data = 'about:blank';
                if (!isIE) element.appendChild(obj);
            }
        }
        element.__resizeListeners__.push(fn);
    };

    window.removeResizeListener = function (element, fn) {
        element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
        if (!element.__resizeListeners__.length) {
            if (attachEvent) element.detachEvent('onresize', resizeListener);
            else {
                element.__resizeTrigger__.contentDocument.defaultView.removeEventListener('resize', resizeListener);
                element.__resizeTrigger__ = !element.removeChild(element.__resizeTrigger__);
            }
        }
    };

    jQuery.fn.simulateClick = function () {
        return this.each(function () {
            if ('createEvent' in document) {
                var doc = this.ownerDocument,
                    evt = doc.createEvent('MouseEvents');
                evt.initMouseEvent('click', true, true, doc.defaultView, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                this.dispatchEvent(evt);
            } else {
                this.click(); // IE Boss!
            }
        });
    };

    (function (old) {
        $.fn.attr = function () {
            if (arguments.length === 0) {
                if (this.length === 0) {
                    return null;
                }

                var obj = {};
                $.each(this[0].attributes, function () {
                    if (this.specified) {
                        obj[this.name] = this.value;
                    }
                });
                return obj;
            }

            return old.apply(this, arguments);
        };
    })($.fn.attr);

    jQuery.fn.closest_all = function (filter) {
        var $found = $(),
            $currentSet = this; // Current place
        while ($currentSet.length) {
            $found = $currentSet.filter(filter);
            if ($found.length) break;  // At least one match: break loop
            // Get all children of the current set
            $currentSet = $currentSet.children();
        }
        return $found; // Return all matches of the collection
    };

    let lastClientWidth = document.documentElement.clientWidth;

    function checkClientWidth() {
        const newClientWidth = document.documentElement.clientWidth;
        if (newClientWidth !== lastClientWidth) {
            
            $(document).trigger('clientWidthChanged', [newClientWidth, lastClientWidth]);

            lastClientWidth = newClientWidth;
        }
        requestAnimationFrame(checkClientWidth);
    }

    requestAnimationFrame(checkClientWidth);
})();
function dInt(dv, dnull) {
    dnull = dnull ? dnull : 0;
    if (dv) dv = Number(dv); else return dnull;
    if (isNaN(dv)) return dnull;
    return dv;
}


